'use strict';

/** @type {import('.')} */
module.exports = Object;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/es-object-atoms@1.1.1/~/es-object-atoms/index.js
// module id = 250
// module chunks = 0